module.exports = __webpack_public_path__ + "static/media/banner-1.c3ac3262.jpeg";